<template lang="pug">
  div
    v-container.py-0.px-4
      v-row.align-center.ma-0.pa-0
        v-col.ma-0.pa-0
          v-layout
            v-col.pa-0.fill-width
              v-row.pt-3(no-gutters align="center")
                v-col.shrink(v-if="checkboxActiveExport || checkboxActiveShipping")
                  y-checkbox.mb-n2(v-model="checkbox" style="height:30px")
                v-col
                  div.s2.basic1000--text.order-title(link @click="openInvoiceDialog = true") # {{ lead.rid }} {{ (lead.processed_at || lead.created) | convertServerDate }}
                v-col.pl-1.shrink
                  v-menu(left :offset-y='true')
                    template(v-slot:activator='{ on }')
                      v-btn.my-auto.px-3.elevation-0(color="info500" v-on="on" height="32" width="100%" :loading="isLoading")
                        .button-AA-small.basic100--text| {{ $t('update') }}
                    v-list.pa-0(dense)
                      template(v-for="(status, index) in statusSelections")
                        v-list-item(:key="status.id" @click="updateStatus(status.id)")
                          v-list-item-title.s2.basic800--text {{ status.name }}
                      v-list-item(@click="openEditCustomerDialog = true")
                        v-list-item-title.s2.basic800--text {{ $t('edit_customer_info') }}
                      template(v-if="!lead.paid && lead.status !== 'partial_payment'")
                        v-list-item(@click="openEditOrderDialog = true")
                          v-list-item-title.s2.basic800--text {{ $t('edit_order') }}
              div.mr-n4.ml-n4.mt-3
                v-divider.basic300
              v-row(no-gutters)
                v-col.pt-3(cols="8")
                  v-chip.mb-2(v-if="lead.cod" color="grey darken-3" x-small)
                    div.white--text.mb-0 {{ $t('cash_on_delivery') }}
                  v-chip.mb-2(v-if="lead.pay_at_shop" color="grey darken-3" x-small)
                    div.white--text.mb-0 {{ $t('pay_at_shop') }}
                  div.c1.primary500--text {{ $t('name') }}: {{ ((lead.shipping_address && lead.shipping_address.name) || lead.name) }}
                  div.c1.primary500--text {{ $t('phone') }}: {{ ((lead.shipping_address && lead.shipping_address.phone) || lead.phone) | phoneFormat }}
                  div.c1.primary500--text(v-if="lead.email") {{ $t('email') }}: {{ lead.email }}
                  div.c1.primary500--text From: {{ lead.form.type === 'store' ? 'Yezza Store' : lead.form.name }}
                  .shipping-method(v-if="lead.shipping")
                    div.c1.primary500--text {{ $t('shipping_method') }}:
                      span.ml-1.font-weight-bold(v-if="lead.pickup") {{ $t('self_pickup') }}
                      span.ml-1.font-weight-bold(v-else) {{ $options.filters.shippingMethodDisplay(lead.shipping.shipping_method) }}
                      v-tooltip(v-model="shippingDetails" color="basic1100" top max-width="250" z-index="3" v-if="lead.shipping.shipping_method === 'manual' && zoneCount > 1 && (lead.shipping.selected_option || lead.shipping.zone_name)")
                        template(v-slot:activator="{ on, attrs }")
                          v-btn(icon x-small @click="shippingDetails = !shippingDetails")
                            eva-icon(name="info-outline" :fill="$vuetify.theme.themes[$theme].primary500" height="16" width="16")
                        div.py-1
                          div.c1.white--text.mb-1(v-if="lead.shipping.shipping_method === 'manual' && lead.shipping.selected_option")
                            strong {{ $t('selected_option') }}:
                            | {{ lead.shipping.selected_option }}
                          div.c1.white--text(v-if="zoneCount > 1 && lead.shipping.zone_name")
                            strong {{ $t('shipping_zone') }}:
                            | {{ lead.shipping.zone_name }}
                v-col(cols="4")
                  div.d-flex.justify-end.mr-n2
                    v-btn.mr-1(v-if="totalQuantity" icon)
                      eva-icon(name="share-outline" @click="shareSheet = !shareSheet" :fill="$vuetify.theme.themes[$theme].primary500" height="23" style="margin-top: 4px")
                    v-btn(icon @click="clickOpenWa")
                      v-icon(color="#455a64" size="25") mdi-whatsapp

              v-row.mt-1(no-gutters)
                v-col(v-if="(lead.extra_fields_data && lead.extra_fields_data.length > 0) || (lead.order_remarks && lead.order_remarks.order_message)")
                  v-btn.pa-0(text color="transparent" :ripple="false" small link @click="openCustomerDetails()")
                    .p2.basic600--text.text-capitalize| {{ $t('more_details') }}
                    eva-icon(:name="openShowCustomerDetails ? 'chevron-up' : 'chevron-down'" :fill="$vuetify.theme.themes[$theme].basic600" height="23" width="23" style="margin-top: 3px")
                v-col(align="right" v-if="!lead.cod && !lead.pay_at_shop")
                  v-btn.pa-0.mr-n1(text color="transparent" :ripple="false" small link @click="openTransactionDetails()")
                    .p2.basic600--text.text-capitalize| {{ $t('transaction_details') }}
                    eva-icon(:name="openShowTransactionDetails ? 'chevron-up' : 'chevron-down'" :fill="$vuetify.theme.themes[$theme].basic600" height="23" width="23" style="margin-top: 3px")
              div.mt-2.mr-n4.ml-n4(:style="{ 'background-color':$vuetify.theme.themes[$theme].basic600T16 }")
                v-card.px-4.py-3(v-if="openShowTransactionDetails" outlined :class="$vuetify.breakpoint.smAndDown ? 'pa-1' : 'pa-3'" style="background-color:transparent; border:none; border-radius:0;")
                  v-layout.my-6(v-if="isFetching")
                    v-row.fill-height.ma-0(align='center' justify='center')
                      v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
                  template(v-for="(transaction, index) in transactions")
                    v-layout(:key="transaction.uid")
                      div.mr-2.body-2(v-if="transactions.length > 1") {{ index + 1 }}.
                      v-col.pa-0.fill-width(:key="transaction.created")
                        v-layout
                          div.c1.basic600--text {{ $t('amount') }}: {{ transaction.amount | displayPrice }}
                          v-icon.ml-1(v-if="transaction.paid" small color="green") mdi-check-circle
                          v-icon.ml-1(v-else small color="red") mdi-minus-circle
                        div.c1.basic600--text(v-if="transaction.paid") {{ transaction.created | convertServerDate }}
                        div.c1.basic600--text {{ $t('gateway') }}: {{ transaction.gateway | paymentGatewayDisplay }}
                        div.c1.basic600--text {{ $t('reference_id') }}: {{ transaction.ref_id || '-' }}
              div.mt-2.mr-n4.ml-n4(:style="{ 'background-color':$vuetify.theme.themes[$theme].basic600T16 }")
                v-card.px-4.py-3(v-if="openShowCustomerDetails" outlined :class="$vuetify.breakpoint.smAndDown ? 'pa-1' : 'pa-3'" style="background-color:transparent; border:none; border-radius:0;")
                  template(v-if="lead.extra_fields_data && lead.extra_fields_data.length > 0")
                    div.c1.basic600--text(v-for="field in lead.extra_fields_data" style="white-space: pre-wrap;") {{ field.name }}: {{ field.value }}
                  template(v-if="lead.order_remarks && lead.order_remarks.order_message")
                    div.c1.basic600--text(:class="lead.extra_fields_data && lead.extra_fields_data.length > 0 ? 'mt-2' : ''")
                      strong {{ $t('customer_message') }}:
                    div.c1.basic600--text(style="white-space: pre-wrap;") {{ lead.order_remarks.order_message }}
              div.mt-3.ml-n4.mr-n4
                template(v-for="p in lead.products")
                  v-row.py-3.px-4(no-gutters :key="p.id")
                    v-col(cols="2")
                      div.p2.textColorHint--text(style="margin-top: 2px") {{ p.quantity }} x {{ p.addons.length > 0 ? ' set' : '' }}
                    v-col
                      div.s1.basic800--text {{ p.name }}
                      v-row.pa-0.ma-0.justify-center.lighten-5.align-center(no-gutters v-for="a in p.addons" :key="a.id")
                        v-col
                          p.p2.mb-0.primary400--text + {{ a.name }}{{ a.quantity_per_set > 1 ? ' x ' + a.quantity_per_set : '' }}
                    v-col.text-end(cols="4")
                      div.p2.textColorHint--text(style="margin-top: 2px")  {{ p.price_per_set * p.quantity | displayPrice }}
                  v-divider.basic300
          .remarks(v-if="lead.remarks")
            v-row.border-bottom
              v-col
                div.caption.font-weight-bold {{ $t('remarks') }}:
                div.caption {{ lead.remarks }}
          .address.caption.mt-2(v-if="lead.shipping_address && !lead.pickup")
            v-row(no-gutters)
              v-col.py-2
                div.nocopy(@click="startClick(lead.shipping_address)")
                  div.c2.font-weight-bold {{ $t('shipping_address') }}:
                  div.c1 {{ lead.shipping_address.address_1 }},
                  div.c1(v-if="lead.shipping_address.address_2") {{ lead.shipping_address.address_2 }},
                  template(v-if="lead.shipping_address.area")
                    div.c1 {{ lead.shipping_address.postcode }} {{ lead.shipping_address.area }},
                    div.c1 {{ lead.shipping_address.suburb }}, {{ lead.shipping_address.city }},
                  div.c1(v-else) {{ lead.shipping_address.postcode }} {{ lead.shipping_address.city }},
                  div.c1 {{ lead.shipping_address.state }}, {{ lead.shipping_address.country }}.
              v-col.px-0.py-2(align="right")
                div
                  template(v-if="lead.shipping")
                    template(v-if="!lead.shipping.tracking_id")
                      v-btn.mb-3(v-if="isCourier && (lead.shipping.status == 'new' || lead.shipping.status == 'error')" outlined x-small height=26 color="info500" @click="clickOpenShipItemDialog()" :style="{'background-color':$vuetify.theme.themes[$theme].infoT08}")
                        .button-AA-tiny.info--text {{ $t('ship_to_this_address') }}
                      v-btn.mb-3(v-if="!isCourier" color="info500" @click="openAddShipItemDialog = true" outlined x-small height=26 :style="{'background-color':$vuetify.theme.themes[$theme].infoT08}")
                        .button-AA-tiny.info--text {{ $t('ship_to_this_address') }}
                  //- template(v-else-if="hasCourier").pa-0.ma-0.text-right
                  template(v-else).pa-0.ma-0.text-right
                    v-btn.mb-3(outlined color="info500" x-small height=26 @click="openAddShipItemDialog = true" :style="{'background-color':$vuetify.theme.themes[$theme].infoT08}")
                      .button-AA-tiny.info--text {{ $t('ship_to_this_address') }}
                div.mb-3(v-if="lead.shipping && (lead.shipping.shipping_method === 'easyparcel' || lead.shipping.shipping_method === 'manual')")
                  v-menu(left offset-y)
                    template(v-slot:activator='{ on, value }')
                      v-btn.elevation-0.mt-1.button-AA-tiny(outlined color="primary500" :style="{'background-color':$vuetify.theme.themes[$theme].basic600T08}"  height=26 x-small light v-on='on') {{ $t('manage') }}
                        eva-icon.ml-1(:name="value ? 'arrow-ios-downward-outline' : 'arrow-ios-upward-outline'" :fill="$vuetify.theme.themes[$theme].primary500" height="15" width="15" style="margin-top: 2px")
                    v-list.pa-0
                      v-list-item(v-if="(isCourier && (lead.shipping.status == 'new' || lead.shipping.status == 'error')) || (!isCourier && hasCourier)" @click="openUpdateCustomerAddress = true")
                        v-list-item-content
                          v-list-item-title.s2.basic800--text {{ $t('edit_address') }}
                      template(v-if="enableEditTracking")
                        v-list-item(@click="openAddTrackingCodeDialog = true")
                          v-list-item-content
                            v-list-item-title.s2.basic800--text {{ (lead.shipping.tracking_id || lead.shipping.on_demand_details)? $t('update_tracking_info') : $t('add_tracking_info') }}
                        //- v-list-item(@click="getParcelLabel(lead.shipping.id)")
                          v-list-item-content
                            v-list-item-title.s2.basic800--text Download Label
              v-col(cols="12")
                template(v-if="lead.shipping && lead.shipping.tracking_id")
                  div.mt-2.c2.font-weight-bold {{ $t('tracking_number') }}:
                  div.c1 {{ lead.shipping.courier }}
                  div.c1 {{ lead.shipping.tracking_id }}
                template(v-if="lead.shipping && lead.shipping.on_demand_details")
                  div.mt-2.c2.font-weight-bold {{ $t('tracking_info') }}:
                  div.c1(v-if="lead.shipping.on_demand !== 'ownRider'") {{ lead.shipping.on_demand }}
                  linkify-text.c1.mb-4(:text="lead.shipping.on_demand_details")
    .modals
      product-invoice(v-if="openInvoiceDialog" :open.sync="openInvoiceDialog" :parentLead.sync="lead")
      ship-item(v-if="openShipItemDialog" :open.sync="openShipItemDialog" :parentLead.sync="lead")
      add-ship-item(v-if="openAddShipItemDialog" :open.sync="openAddShipItemDialog" :parentLead.sync="lead" :menu="menu" @openRider="openRiderListDialog = true")
      rider-list(v-if="openRiderListDialog" :open.sync="openRiderListDialog" :leads.sync="riderLeads")
      add-customer-address(v-if="openUpdateCustomerAddress" :open.sync="openUpdateCustomerAddress" :parentLead.sync="lead")
      add-tracking-code(v-if="openAddTrackingCodeDialog" :open.sync="openAddTrackingCodeDialog" :parentLead.sync="lead" :skippable="false")
      edit-customer-info(v-if="openEditCustomerDialog" :open.sync="openEditCustomerDialog" :parentLead.sync="lead")
      edit-order(v-if="openEditOrderDialog" :open.sync="openEditOrderDialog" :parentLead.sync="lead" )
      y-dialog(v-if="lead.shipping" v-model='openRetryShipItemDialog', max-width='320' persistent)
        v-card
          v-card-title.h6.danger500--text.px-4 {{ $t('shipping_error') }} !
          v-card-text.p2.primary500--text.px-4 {{ $t('shipping_error_text', { method: $options.filters.shippingMethodDisplay(lead.shipping.shipping_method) }) }}
          v-card-actions
            v-spacer
            v-btn(color='white' text @click='openAddShipItemDialog = true; openRetryShipItemDialog = false;')
              .button-Aa-small.primary400--text {{ $t('select_new') }}
            v-btn(color='info500' depressed dark @click='openShipItemDialog = true; openRetryShipItemDialog = false;')
              .button-AA-small.basic100--text {{ $t('retry') }}
      y-bottom-sheet(v-model="shareSheet" inset max-width="600px")
        v-card.py-4(flat)
          div.mx-6.s2.primary400--text {{ $t('share_invoice_link_by') }}
          v-list.pa-0
            v-list-item(@click="shareUrlToWA")
              v-list-item-avatar.my-0
                v-icon(color="#455A64") fab fa-whatsapp
              v-list-item-title.s2.basic1000--text WhatsApp
            v-list-item(@click="copyUrl" v-clipboard:copy="getShareLinkURL()")
              v-list-item-avatar.my-0
                v-icon mdi-content-copy
              v-list-item-title.s2.basic1000--text {{ $t('copy_url') }}
                div.c1.primary400--text {{getShareLinkURL()}}
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ShipItem from '@/components/dialogs/order/ShipItem.vue'
import AddShipItem from '@/components/dialogs/order/AddShipItem.vue'
import ProductInvoice from '@/components/dialogs/database/ProductInvoice.vue'
import RiderList from '@/components/dialogs/order/RiderList.vue'
import AddCustomerAddress from '@/components/dialogs/database/AddCustomerAddress.vue'
import AddTrackingCode from '@/components/dialogs/order/AddTrackingCode.vue'
import EditCustomerInfo from '@/components/dialogs/database/EditCustomerInfo.vue'
import EditOrder from '@/components/dialogs/database/EditOrder.vue'
import LinkifyText from '@/components/LinkifyText.vue'

export default {
  name: 'OrderItem',
  props: ['parentLead', 'index', 'menu', 'checkboxActiveExport', 'checkboxActiveShipping', 'zoneCount'],
  components: { ShipItem, AddShipItem, ProductInvoice, RiderList, AddCustomerAddress, AddTrackingCode, EditCustomerInfo, EditOrder, LinkifyText },
  data: () => ({
    isClicked: false,
    openInvoiceDialog: false,
    openShipItemDialog: false,
    openAddShipItemDialog: false,
    openRetryShipItemDialog: false,
    openAddTrackingCodeDialog: false,
    openRiderListDialog: false,
    openShowCustomerDetails: false,
    openShowTransactionDetails: false,
    openUpdateCustomerAddress: false,
    openEditCustomerDialog: false,
    openEditOrderDialog: false,
    shareSheet: false,
    isFetching: false,
    latestCompany: null,
    trackingId: null,
    isLoading: false,
    transactions: [],
    shippingDetails: false,
    setTimeOutTooltip: null,
    statusSelections: [
      {
        name: 'Shipped',
        id: 'shipped'
      },
      {
        name: 'Received',
        id: 'received'
      },
      {
        name: 'Cancelled',
        id: 'cancelled'
      }
    ],
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required']
    }
  }),
  computed: {
    ...mapState('user', ['member']),
    lead: {
      get() {
        return this.parentLead
      },
      set(newValue) {
        this.$emit('edited', newValue)
      }
    },
    totalQuantity () {
      if (!this.lead.products) return 0
      return this.lead.products.reduce((sum, p) => {
        return sum + p.quantity
      }, 0)
    },
    totalPrice () {
      if (!this.lead.products) return 0
      return this.lead.products.reduce((sum, p) => {
        return sum + (p.price * p.quantity)
      }, 0)
    },
    hasCourier () {
      return this.menu.easyparcel_enabled || this.menu.zepto_enabled
    },
    isCourier () {
      return this.lead.shipping && ['easyparcel', 'zepto'].includes(this.lead.shipping.shipping_method)
    },
    enableEditTracking () {
      if (!this.lead.shipping) {
        return false
      }
      switch (this.lead.shipping.shipping_method){
        case 'easyparcel':
          return this.lead.shipping.status == 'pending' || this.lead.shipping.status == 'processing'
        case 'manual':
          return this.lead.shipping.status == 'new'
      }
      return false
    },
    checkbox: {
      get () {
        return this.lead.checkboxSelected
      },
      set (val) {
        this.$emit('checkbox-updated', [val, this.lead])
      }
    },
    riderLeads () {
      return [this.lead]
    }
  },
  watch: {
    shippingDetails (val) {
      if (val) {
        this.setTimeOutTooltip = setTimeout(() => {
          this.shippingDetails = false
        }, 5000)
      } else {
        if (this.setTimeOutTooltip) {
          clearTimeout(this.setTimeOutTooltip)
        }
      }
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    clickOpenShipItemDialog () {
      if (this.lead.shipping.status == 'error') {
        this.openRetryShipItemDialog = true
        return
      }
      this.openShipItemDialog = true
    },
    openCustomerDetails() {
      this.openShowCustomerDetails = !this.openShowCustomerDetails
      if (this.openShowCustomerDetails) {
        this.openShowTransactionDetails = false
      }
    },
    openTransactionDetails() {
      this.openShowTransactionDetails = !this.openShowTransactionDetails
      if (this.openShowTransactionDetails) {
        this.openShowCustomerDetails = false
      }
      if (this.transactions.length != 0) return
      this.isFetching = true
      this.axios.get(`/transactions?lead=${this.lead.id}&company=${this.lead.company}`).then((response) => {
        this.transactions = response.data.results
        this.isFetching = false
      })
    },
    updateStatus(status) {
      this.isLoading = true
      this.axios.patch(`/leads/${this.lead.pid}/`, { status: status })
        .then(resp => {
          this.$emit('deleted', resp.data)
          this.openDeleteDialog = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    getShareLinkURL () {
      if (this.$subdomain) {
        return `${this.$subdomain}.${process.env.VUE_APP_SHORT_URL_DOMAIN}/invoices/${this.lead.pid}`
      } else {
        return `http://localhost:8080/invoices/${this.lead.pid}`
      }
    },
    copyUrl() {
      this.showMessage(['success', this.$t('success_message.link_copied_to_clipboard')])
      this.shareSheet = false
    },
    clickOpenWa () {
      const phone = ((this.lead.shipping_address && this.lead.shipping_address.phone) || this.lead.phone)
      window.open(`https://api.whatsapp.com/send?phone=${this.$options.filters.phoneSanitized(phone)}`)
    },
    shareUrlToWA() {
      window.open(`https://api.whatsapp.com/send?text=${this.getShareLinkURL()}`)
    },
    getParcelLabel(shipping){
      this.axios.get(`/shipping/shippings/${shipping}/parcel-label`)
        .then(resp => {
          window.open(resp.data.url)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.parcel_label_not_available')])
        })
    },
    startClick (address) {
      let addr = `${address.address_1},${address.address_2 ? ` ${address.address_2},` : ''} ${address.postcode},${address.area ? ` ${address.area}, ${address.suburb},` : ''} ${address.city}, ${address.state}, ${address.country}.`
      this.$copyText(addr).then(() => {
        this.showMessage(['success', this.$t('success_message.address_copied_to_clipboard')])
      }).catch(() => {
        this.showMessage(['error', this.$t('error_message.copy_address_failed')])
      })
    }
  }
}
</script>

<style scoped>
.order-title:hover{
  text-decoration: underline;
  cursor: pointer;
}
.border-bottom{
  border-bottom: 1px solid var(--v-basic300);
  border-radius: 0 !important;
}
.nocopy {
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -o-user-select: none;
  user-select: none;
}
</style>

<i18n>
{
  "en": {
    "shipping_error_text": "There was error during prosessing your shipping. You can either retry with same shipper ({method}) or select new."
  },
  "id": {
    "shipping_error_text": "Terjadi kesalahan saat memproses pengiriman kamu. kamu dapat mencoba lagi dengan pengirim yang sama ({method}) atau pilih baru."
  }
}
</i18n>
